<template>
  <div class="container-fluid container-fluid-login" >
    <div class="header-logo">
        <img :src="$img('logo.png')" />
    </div>
    <form ref="loginForm" id='form' class='form row' @submit="handleSubmit" autocomplete="on" action="/login" method="post">
      <div class="col-sm-24">
        <div class="form-input-with-icon--wrapper">
            <label class="form-label" for="txt_user"><svg-item :size="32" :icon="'correo'" :color="'--login-input-color'"></svg-item></label>
            <input class="form-input" :placeholder="this.translate('user')" ref="txt_user" type="email" id="txt_user" name="username" autocomplete="username" inputmode="email" autocapitalize="none" autocorrect="off" spellcheck="false" v-model="email" />
        </div>
        <div class="form-input-with-icon--wrapper">
            <label class="form-label" for="txt_password"><svg-item :size="32" :icon="'candado'" :color="'--login-input-color'"></svg-item></label>
            <div class="password-input-inner">
                <input class="form-input" :placeholder="this.translate('password')" ref="txt_password" :type="showLoginPassword ? 'text' : 'password'" id="txt_password" name="password" autocomplete="current-password" autocapitalize="none" autocorrect="off" spellcheck="false" v-model='password' />
                <button type="button" class="password-toggle-btn" @click="showLoginPassword = !showLoginPassword" :aria-label="showLoginPassword ? translate('hidePassword') : translate('showPassword')">
                    <svg-item v-if="!showLoginPassword" :size="24" :icon="'ojo'" :color="'--login-input-color'"></svg-item>
                    <svg-item v-else :size="24" :icon="'ojo-cerrado'" :color="'--login-input-color'"></svg-item>
                </button>
            </div>
        </div>
        <div class="remember-password">
            <input type="checkbox" id="cbx_remember_password" v-model="rememberPassword" @change="onRememberPasswordChange" />
            <label class="form-label" for="cbx_remember_password">{{ translate('rememberPassword') }}</label>
        </div>
        <div class="form-input-with-icon--wrapper" v-if="langs.length > 1">
            <label class="form-label" for="txt_lang" style="margin-right: 4px;">
                <svg-item :size="32" :icon="'language'" :color="'--login-input-color'"></svg-item>
            </label>
            <select class="form-input" v-model='lang' id="txt_lang" v-jump:focus="'btn_login'" @change="onLanguageChange">
                <option v-for="l in langs" v-bind:value="l.key" v-bind:key="l.key">
                    {{ l.text }}
                </option>
            </select>
        </div>
        <button ref="btn_login" id="btn_login" type="submit" class="btn btn-primary btn-lg btn-heavy" :disabled="loading" v-lang.login> Ingresar </button>
        <div class="form-block">
            <router-link class='password-not' :to="{name:'reset-password'}" v-lang.forgottenPassword>¿Olvido su contraseña?</router-link>
            <span class="register"> <span v-lang.notAccount>No tenés cuenta?</span> <router-link class='login-register' :to="{name:'register'}" v-lang.registerHere></router-link></span>
            <div class="form-block" style="margin-top: 8px;">
                <router-link class="password-not" :to="{ name: 'cotizacion' }">{{ translate('cotizacionDesdeLogin') }}</router-link>
            </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '../../services/dialogs.js';
import router from '../../router';
import bus from '../../services/bus-event';
import Forms from '../mixins/forms';
import availableLanguages from '@/services/language';

const REMEMBER_CREDENTIALS_KEY = 'remember_login_credentials';

export default {
    name: 'login',
    data () {
        return {
            email: '',
            password: '',
            rememberPassword: false,
            showLoginPassword: false,
            loading: false,
            lang: 'es',
            langs: []
        };
    },
    computed: {
        ...mapGetters({
            checkLogin: 'auth/checkLogin',
            isMobile: 'device/isMobile',
            isInternetOnline: 'device/internetOnline'
        })
    },
    methods: {
        ...mapActions({
            doLogin: 'auth/login',
            resetRegisterTempData: 'tempCache/reset',
            confirmInternetConnection: 'device/confirmInternetConnection'
        }),
        async saveCredentials (email, password) {
            try {
                if (!navigator.credentials || !navigator.credentials.store) return;

                let cred = null;

                // Safari/iOS can be inconsistent with PasswordCredential(form),
                // so we try both constructor and credentials.create fallback.
                if (window.PasswordCredential) {
                    try {
                        if (this.$refs.loginForm) {
                            cred = new window.PasswordCredential(this.$refs.loginForm);
                        } else {
                            cred = new window.PasswordCredential({
                                id: email,
                                password: password,
                                name: email
                            });
                        }
                    } catch (constructorError) {
                        console.warn('PasswordCredential constructor fallo, usando fallback', constructorError);
                    }
                }

                if (!cred && navigator.credentials.create) {
                    cred = await navigator.credentials.create({
                        password: {
                            id: email,
                            password: password,
                            name: email
                        }
                    });
                }

                if (cred) {
                    await navigator.credentials.store(cred);
                }
            } catch (e) {
                console.warn('No se pudo solicitar guardar credenciales', e);
            }
        },
        loadRememberedCredentials () {
            try {
                const raw = window.localStorage.getItem(REMEMBER_CREDENTIALS_KEY);
                if (!raw) return;
                const data = JSON.parse(raw);
                if (data && data.email) {
                    this.email = data.email;
                    this.password = data.password || '';
                    this.rememberPassword = true;
                }
            } catch (e) {
                console.warn('No se pudieron cargar credenciales recordadas', e);
            }
        },
        persistRememberedCredentials (email, password) {
            try {
                if (this.rememberPassword) {
                    window.localStorage.setItem(REMEMBER_CREDENTIALS_KEY, JSON.stringify({
                        email: email,
                        password: password
                    }));
                } else {
                    window.localStorage.removeItem(REMEMBER_CREDENTIALS_KEY);
                }
            } catch (e) {
                console.warn('No se pudieron guardar credenciales recordadas', e);
            }
        },
        onRememberPasswordChange () {
            if (!this.rememberPassword) {
                try {
                    window.localStorage.removeItem(REMEMBER_CREDENTIALS_KEY);
                } catch (e) {
                    console.warn('No se pudieron borrar credenciales recordadas', e);
                }
            }
        },
        async handleSubmit (event) {
            if (event && event.preventDefault) {
                event.preventDefault();
            }
            if (this.loading) return;
            await this.login();
        },
        async login () {
            this.loading = true;
            let email = this.email;
            let password = this.password;
            this.confirmInternetConnection();
            this.doLogin({email, password}).then(async data => {
                this.persistRememberedCredentials(email, password);
                await this.saveCredentials(email, password);
                if (this.langs.length > 1 && !data.user.lang) {
                    this.$setLang(this.lang);
                }
                this.loading = false;
                this.resetRegisterTempData({key: 'view', subKey: 'register'});
                this.resetRegisterTempData({key: 'view', subKey: 'upgradeChofer'});
                // router.push({ name: 'trips' });
                // router.rememberBack();
            }, error => {
                this.loading = false;
                console.log('isInternetOnline', this.isInternetOnline);
                if (!this.isInternetOnline) {
                    this.loading = false;
                    dialogs.message(this.translate('conectionError'), { duration: 10, estado: 'error' });
                    return;
                }
                if (error && error.status === 401 && error.data && error.data.error === 'invalid_credentials') {
                    dialogs.message(this.translate('loginError'), { duration: 10, estado: 'error' });
                    this.jumpToFirstInput();
                } else if (error && error.status === 422 && error.data && error.data.error === 'user_inactive') {
                    dialogs.message(this.translate('userInactive'), { duration: 10, estado: 'error' });
                    this.jumpToFirstInput();
                } else {
                    dialogs.message(this.translate('generalError'), { duration: 10, estado: 'error' });
                    console.error(error);
                }
            });
        },
        onClearClick () {
            router.back();
        },
        onLanguageChange () {
            if (this.langs.length > 1) {
                this.$setLang(this.lang);
                this.language = this.$getLang();
            }
        }
    },

    mounted () {
        this.language = this.$getLang();
        if (availableLanguages) {
            for (const key in availableLanguages) {
                if (availableLanguages.hasOwnProperty(key)) {
                    const element = availableLanguages[key];
                    if (key !== 'first') {
                        this.langs.push({
                            text: element.name_language,
                            key: key
                        });
                    }
                }
            }
        }
        this.lang = this.language;
        this.loadRememberedCredentials();
        bus.on('clear-click', this.onClearClick);
    },
    beforeDestroy () {
        bus.off('clear-click', this.onClearClick);
    },
    mixins: [Forms]
};
</script>

<style scoped>
    .container-fluid {
        background: var(--login-background);
        min-height: 100%;
    }
    .form {
        padding: 0 1.2em;
    }
    .header-logo {
        width: 100%;
        padding: 2em 1em 1.6em 1em;
        text-align: center;
        margin-bottom: 1em;
    }
    .header-logo img {
        max-width: 300px;
        width: 100%;
        opacity: var(--login-logo-opacity);
        height: var(--login-logo-height);
    }
    .password-not,
    .register {
        font-size: 1.2em;
        color: var(--login-password-and-register-color);
        display: block;
    }
    .register a {
        color: var(--login-password-and-register-color);
        font-weight: 500;
    }
    .password-not {
        font-weight: 500;
        margin-bottom: .4em;
        margin-top: .6em;
    }
    .form-input-wrapper .form-input {
        border-bottom: 1px solid var(--login-input-color);
        color: var(--login-text-color);
    }

    .form-input-wrapper .form-label {
        color: var(--label-font-color);
    }

    .form-input-with-icon--wrapper {
        border-bottom: 1px solid var(--login-input-color);
    }
    .form-input-with-icon--wrapper .form-input {
        color: var(--login-input-color);
    }
    .form-input-with-icon--wrapper .form-input::placeholder {
        color: var(--login-input-color);
    }
    .remember-password {
        display: flex;
        align-items: center;
        gap: 0.5em;
        margin: 1em 0 0.4em;
    }
    .remember-password input[type="checkbox"] {
        width: 1.15em;
        height: 1.15em;
        margin: 0;
        flex-shrink: 0;
        accent-color: var(--secondary-color, #F4C400);
    }
    .remember-password .form-label {
        margin: 0;
        color: var(--login-password-and-register-color);
        font-size: 1.05em;
        font-weight: 400;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Login.vue